import config from './enviromentConfig';

export const REACT_APP_LENDING_GRAPHQL_URL = config.REACT_APP_LENDING_GRAPHQL_URL;
export const REACT_APP_LENDUS_URL = config.REACT_APP_LENDUS_URL;
